import $ from 'jquery';

export default {
    render() {
        const $colorSwatches = $('.js-variant-attribute-value .js-color');
        $colorSwatches.each((i) => {
            const $colorSwatch = $colorSwatches.eq(i);
            const colorCode = $colorSwatch.data('color-code');
            if (colorCode) {
                $colorSwatch.css('background', `#${colorCode}`);
            }
        });
    },
};
